export const ADDRESSES = {
  MERKLE_DISTRIBUTOR1: "0x78C13B8511DCfA8346b3470eA7Defe28d5314D90",
  MERKLE_DISTRIBUTOR2: "0x578F36c012EDa5237f82886A593d92B61F5d418C",
  MERKLE_DISTRIBUTOR3: "0x9Ae5f7639610eF424e1312E422eFAA63549754Cb",
  MERKLE_DISTRIBUTOR4: "0xcf4Cbfac1ead9D6b313150E580a32Dec3A231a57",
  MERKLE_DISTRIBUTOR5: "0xB5df353488637Fb1d2E300A4f6EaD8b914570118",
  MERKLE_DISTRIBUTOR6: "0x2951eF72d192068eA4F69f9EdAFEBDD4949f84f0",
  MERKLE_DISTRIBUTOR7: "0xEc51159cC713E3111Fb6F9a2282eD0Ca98553EB8",
  MERKLE_DISTRIBUTOR8: "0x31A83028584F1b4C838ea63E88e4856E4EeAeD88",
  MERKLE_DISTRIBUTOR9: "0x07d80147a544C596A5759b1Ee5912418667A70Dc",
};

export const winnersUrls = [
  "https://drive.google.com/file/d/1VXDoHSKghMwqI_8iAba3nipjnDM-NSHT/view",
];

export const INITIAL_RAFFLE_DATE = new Date(Date.UTC(2023, 5, 14, 12));

export const calculateRaffleDate = (epochIndex: number) => {
  const daysCount = epochIndex <= 0 ? 0 : epochIndex * 14;
  const newRaffleDate = new Date(INITIAL_RAFFLE_DATE);
  newRaffleDate.setDate(newRaffleDate.getDate() + daysCount);
  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  };
  return newRaffleDate
      .toLocaleString("en-US", options)
      .toUpperCase();
};

export const contractAddresses = [
  ADDRESSES.MERKLE_DISTRIBUTOR1,
  ADDRESSES.MERKLE_DISTRIBUTOR2,
  ADDRESSES.MERKLE_DISTRIBUTOR3,
  ADDRESSES.MERKLE_DISTRIBUTOR4,
  ADDRESSES.MERKLE_DISTRIBUTOR5,
  ADDRESSES.MERKLE_DISTRIBUTOR6,
  ADDRESSES.MERKLE_DISTRIBUTOR7,
  ADDRESSES.MERKLE_DISTRIBUTOR8,
  ADDRESSES.MERKLE_DISTRIBUTOR9,
];
export const lotteryHeldDate = new Date(Date.UTC(2023, 5, 14, 12));

// 1st october & 8th october, disabled all buttons
export const isTechnicalWorks = false;
// 8 oct & 16 oct show green background
export const successTechnicalWorks = true;
// to 16th October show global disclaimer
export const showDisclaimer = false;

// export const isTechnicalWorks = Date.now() > 1664625600000 && Date.now() < 1665230400000;// 1st october & 8th october
// export const successTechnicalWorks = Date.now() > 1665230400000 && Date.now() < 1665921600000; // 8 oct & 16 oct
// export const showDisclaimer = Date.now() < 1665921600000; // 16th October
